module.exports = __webpack_public_path__ + "static/assets/3afcdd7a2526210886418c1bc0d3d4ba.png";